document.documentElement.classList.add("js");
/* Homepage demo interactions: scroll reveal, collection tabs, mobile menu, mood switch.
   Plain DOM, no dependencies, so every piece ports 1:1 into a theme asset later. */
(function () {
  'use strict';

  // 1. Scroll reveal: fade sections in once, as they enter the viewport
  var revealTargets = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealTargets.forEach(function (el) { observer.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-in'); });
  }

  // 2. Collection tabs on the shelf (click + arrow keys), and keep the "see all" link in sync
  var tabs = Array.prototype.slice.call(document.querySelectorAll('.tabs__tab'));
  var moreLink = document.getElementById('shelf-more');
  function selectTab(tab) {
    tabs.forEach(function (other) {
      var active = other === tab;
      var panel = document.getElementById(other.getAttribute('aria-controls'));
      if (!panel) return;
      other.setAttribute('aria-selected', String(active));
      other.tabIndex = active ? 0 : -1;
      panel.hidden = !active;
      if (active && moreLink) {
        panel.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
        moreLink.href = panel.dataset.more;
        moreLink.querySelector('span').textContent = panel.dataset.moreLabel;
      }
    });
  }
  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () { selectTab(tab); });
    tab.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      var step = event.key === 'ArrowRight' ? 1 : -1;
      var next = tabs[(index + step + tabs.length) % tabs.length];
      next.focus();
      selectTab(next);
    });
  });

  // 3. Mobile menu toggle
  var menuButton = document.querySelector('.masthead__menu');
  var nav = document.getElementById('site-nav');
  if (menuButton && nav) {
    menuButton.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
  }

  // 4. Demo-only mood switch (Daylight / Dusk). Remembered per browser when storage is available.
  var moodButtons = document.querySelectorAll('[data-mood-set]');
  function setMood(mood) {
    document.documentElement.dataset.mood = mood;
    moodButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.moodSet === mood));
    });
    try { localStorage.setItem('skatheia-demo-mood', mood); } catch (error) { /* private mode: fine */ }
  }
  moodButtons.forEach(function (button) {
    button.addEventListener('click', function () { setMood(button.dataset.moodSet); });
  });
  var seasonal = /^(bfcm|christmas|christmas_home)$/.test(document.documentElement.dataset.page); // these carry their own palette
  try {
    var saved = new URLSearchParams(location.search).get('mood') || localStorage.getItem('skatheia-demo-mood');
    if (!seasonal && (saved === 'dusk' || saved === 'daylight')) setMood(saved);
  } catch (error) { /* keep default mood */ }
})();

/* Landing pages (Wide fit, Black Friday, Christmas) and the Christmas homepage: offer clock, estimated arrival,
   sticky bar, quick-buy sheet. On a page with the sheet, every print opens it (size, protection, fit, upper).
   The sheet's button is a plain Shopify "add to cart" link for the chosen variants, opened in
   the same tab (in-app browsers block new tabs), so the shopper lands on the real cart page.
   Prices, variant ids and the offer come from the #landing-data JSON embedded at assembly time. */
(function () {
  'use strict';
  var dataNode = document.getElementById('landing-data');
  if (!dataNode) return; // not a landing page. The Christmas homepage has the data but no sheet: it stops after the offer clock

  var data = JSON.parse(dataNode.textContent);
  var byId = function (id) { return document.getElementById(id); };
  var each = function (selector, fn) { Array.prototype.forEach.call(document.querySelectorAll(selector), fn); };
  var money = function (amount) { return '$' + amount.toFixed(2); };
  var pacific = function (date, options) { options.timeZone = 'America/Los_Angeles'; return date.toLocaleDateString('en-US', options); };
  var day = 24 * 60 * 60 * 1000, now = Date.now();

  // 1. Offer clock, before anything that needs <dialog>: an expired offer must never stay on screen.
  var offerOn = Boolean(data.discount) && now < Date.parse(data.discount.ends);
  var off = offerOn ? data.discount.amount : 0;
  if (offerOn) {
    var lastDay = new Date(Date.parse(data.discount.ends));
    each('[data-offer-end]', function (el) { el.textContent = pacific(lastDay, { month: 'short', day: 'numeric', year: 'numeric' }); });
  } else {
    each('[data-offer]', function (el) { el.hidden = true; });
    each('[data-price]', function (el) { el.textContent = el.dataset.price; });
  }

  // 2. Estimated arrival, printed as dates. An estimate, and labelled as one. The window comes with the page
  //    data (production + shipping days of that landing); without it, the 2 to 5 weeks of the Shipping page.
  var eta = data.eta || { fast: 14, slow: 35 };
  var from = pacific(new Date(now + eta.fast * day), { month: 'short', day: 'numeric' });
  var to = pacific(new Date(now + eta.slow * day), { month: 'short', day: 'numeric' });
  var unbroken = function (text) { return text.replace(/ /g, ' '); }; // a date range wraps as one piece, never "Oct / 12"
  each('[data-eta]', function (el) { el.textContent = 'Est. arrival ' + unbroken(from + ' to ' + to); });
  each('[data-eta-sentence]', function (el) { el.textContent = 'Estimated between ' + from + ' and ' + to + ' if you order today.'; });

  // 3. Sticky bar: appears after the hero, steps aside while the prints are on screen.
  //    Set up before the sheet, so a landing without a quick-buy sheet still gets its bar.
  var bar = byId('lp-bar'), prints = byId('prints');
  if (bar && prints) {
    var ticking = false;
    var updateBar = function () {
      var rect = prints.getBoundingClientRect();
      var printsOnScreen = rect.top < window.innerHeight * 0.6 && rect.bottom > window.innerHeight * 0.4;
      bar.hidden = window.scrollY < 600 || printsOnScreen;
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(updateBar); }
    }, { passive: true });
    updateBar();
  }

  // 4. Quick-buy sheet
  var sheet = byId('buy-sheet'), form = byId('buy-form');
  if (!sheet || !form || !sheet.showModal) return; // no sheet on this page, or no dialog support: the cards stay plain links to the product pages
  var hint = byId('buy-sheet-hint'), fine = byId('buy-sheet-fine'), total = byId('buy-sheet-total');
  var current = null; // handle of the print shown in the sheet
  var chosen = function (name) { var input = form.querySelector('input[name="' + name + '"]:checked'); return input ? input.value : ''; };
  var inputFor = function (name, value) { // match by value, never by building a selector from stored text
    return Array.prototype.filter.call(form.querySelectorAll('input[name="' + name + '"]'), function (input) { return input.value === value; })[0];
  };
  var pickKey = 'skatheia-landing-pick-' + (document.documentElement.dataset.page || 'page');
  var saved = {};
  try {
    var stored = JSON.parse(localStorage.getItem(pickKey));
    if (stored && typeof stored === 'object') saved = stored;
  } catch (error) { saved = {}; }
  if (!saved.fit) saved.fit = data.defaultFit;

  function say(text) { hint.textContent = ''; window.setTimeout(function () { hint.textContent = text; }, 30); } // re-announced each time

  function variantId() {
    var fit = data.fits.indexOf(chosen('fit')), material = data.materials.indexOf(chosen('material')), size = data.sizes.indexOf(chosen('size'));
    if (fit < 0 || material < 0 || size < 0) return null;
    return data.products[current].ids[(fit * data.materials.length + material) * data.sizes.length + size];
  }

  function refresh() {
    var fit = chosen('fit'), material = chosen('material'), protection = chosen('protection');
    var soldOut = data.products[current].soldOut, dropped = '';
    form.querySelectorAll('input[name="size"]').forEach(function (input) {
      input.disabled = soldOut.indexOf([fit, material, input.value].join('|')) !== -1;
      if (input.disabled && input.checked) { input.checked = false; dropped = input.value; }
    });
    var size = chosen('size'), list = data.prices[fit + '|' + material];
    each('[data-sheet-value="size"]', function (el) { el.textContent = size ? size + ', insole ' + data.insole[size] + ' mm' : 'Choose a size'; });
    each('[data-sheet-price]', function (el) { el.textContent = money(data.prices[fit + '|' + el.dataset.sheetPrice] - off); });
    byId('buy-sheet-list').textContent = money(list);
    byId('buy-sheet-now').textContent = money(list - off);
    var due = list - off + (protection === 'yes' ? data.protection.price : 0);
    total.textContent = money(due);
    say(dropped ? dropped + ' is sold out in this fit and upper. Pick another size.'
      : !size ? 'Tap ' + (data.whose || 'your') + ' size first.'
      : !protection ? size + ' picked. Now choose Yes or No on Fit Protection.'
      : 'Ready: ' + [fit, size].join(', ') + '.');
    fine.textContent = money(due + data.shipping) + ' at checkout with ' + money(data.shipping) + ' US shipping, before any sales tax. Est. arrival ' + from + ' to ' + to + '.';
  }

  function open(handle) {
    current = handle;
    var product = data.products[handle];
    byId('buy-sheet-title').textContent = product.title;
    byId('buy-sheet-image').src = product.image;
    // carry her size, fit and upper from the last print she looked at: she should only have to choose once
    ['size', 'fit', 'material'].forEach(function (name) {
      var input = saved[name] && inputFor(name, saved[name]);
      if (input) input.checked = true;
    });
    refresh();
    sheet.showModal();
    byId('buy-sheet-title').focus();
  }

  each('[data-quick-buy]', function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault(); // without JavaScript these are ordinary links to the product page
      open(trigger.dataset.quickBuy);
    });
  });
  form.addEventListener('change', function (event) {
    ['fit', 'material'].forEach(function (name) { saved[name] = chosen(name); });
    if (chosen('size')) saved.size = chosen('size'); // keep the last real size even if this print has it sold out
    try { localStorage.setItem(pickKey, JSON.stringify(saved)); } catch (error) { /* private mode */ }
    refresh();
    // once a size is tapped, bring the required protection choice into view
    if (event.target.name === 'size' && !chosen('protection')) form.querySelector('.protect').scrollIntoView({ block: 'nearest' });
  });
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var id = variantId(), firstSize = form.querySelector('input[name="size"]:not(:disabled)');
    if (!id) { say('Tap ' + (data.whose || 'your') + ' size first.'); if (firstSize) firstSize.focus(); return; }
    if (!chosen('protection')) { say('Choose Yes or No on Fit Protection to continue.'); form.querySelector('input[name="protection"]').focus(); return; }
    var query = 'id[]=' + id + (chosen('protection') === 'yes' ? '&id[]=' + data.protection.id : '');
    window.location.href = data.store + '/cart/add?' + query; // adds to her cart, keeps what is already in it
  });
  byId('buy-sheet-close').addEventListener('click', function () { sheet.close(); });
  sheet.addEventListener('click', function (event) {
    if (event.target !== sheet) return; // only a click on the backdrop closes
    var box = sheet.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) sheet.close();
  });
})();
